import api from '../../../App/socket';

export const sendSMSRequest = (template_id, lead_id) => (
    api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'SendSMS',
        options: {
            where: {
                template_id, lead_id,
            },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/send_sms_request.js